var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// 参考ua-parser-js
var DEFAULT_PATTERNS = {
    baiduApp: /baiduboxapp/i,
    quark: /quark/i,
    wechat: /micromessenger/i,
    huawei: /huawei/i,
    harmonyOS: /harmonyos/i,
    oppo: /heytap/i,
    vivo: /vivo/i,
    android: /android/i,
    ios: /iphone|ipad/i,
    qq: /\b(qq)\/([\w\.]+)/i,
    qqBrowser: /m?qqbrowser\/([\w\.]+)/i,
};
var UAParser = /** @class */ (function () {
    function UAParser(ua, patterns) {
        this.ua = ua;
        this.patterns = __assign(__assign({}, DEFAULT_PATTERNS), patterns);
    }
    UAParser.prototype.testUA = function (key) {
        return !!this.ua.match(this.patterns[key]);
    };
    return UAParser;
}());
export default UAParser;
